module.exports = __webpack_public_path__ + "static/media/beatstyle-iphone-home.c972eb13.png";